import React from 'react';

const SacredImages = () => (
  <div className="max-w-4xl mx-auto mt-12">
    <div className="card-temple">
      <h3 className="text-2xl font-bold text-saffron mb-8 text-center">
        Sacred Images from the Temple
      </h3>
      
      <div className="grid md:grid-cols-2 gap-8">
        <div className="text-center">
          <img
            src="https://customer-assets.emergentagent.com/job_krishna-temple/artifacts/flz1rz21_ulsav%20murti%20abhishekam%20aarattu.png"
            alt="Mahotsava murti abhishekam aarattu ceremony"
            className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
          />
        </div>
      </div>
      
      <div className="text-center mt-8">
        <img
          src="https://customer-assets.emergentagent.com/job_krishna-temple/artifacts/aumy0ddz_Glimpses%20of%20Samaradhana%20and%20arattu%20then%20and%20now._20250930_163557_0000.png"
          alt="Glimpses of Samaradhana and arattu then and now"
          className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
        />
      </div>
      
      <div className="grid md:grid-cols-2 gap-8 mt-8">
        <div className="text-center">
          <img
            src="https://customer-assets.emergentagent.com/job_devaswom-preview/artifacts/teuw9s3x_1000059147.png"
            alt="Temple ceremony"
            className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
          />
          <p className="text-sm text-gray-600 mt-2">Special Tulsi Devi decoration on Diwali by Bajrangbali Yuvajan, Kodungallur</p>
        </div>
        
        <div className="text-center">
          <img
            src="https://customer-assets.emergentagent.com/job_devaswom-preview/artifacts/74gouyzz_1000059149.png"
            alt="Temple ceremony"
            className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
          />
        </div>
      </div>
    </div>
  </div>
);

export default SacredImages;
